import React from "react";
import styles from "./news.module.css";
import { newsFetch, getDate } from "../../util/auth.js";

class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }
  createMarkup(news) {
    return { __html: news.description };
  }


  newsForm(news) {
    return (
      <div className={styles.container} key={news.id}>
        <div className={styles.date}>
          <span>{getDate(news.pubDate)}</span>
        </div>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={this.createMarkup(news)}
        />
      </div>
    );
  }

  componentDidMount() {
        var request = { From: null, To: null, Count: 100 };
        newsFetch(request, (news) => {
          this.setState({ data: news });
    });
  }

  render() {
    return (
      <div>
        {this.state.data.map(news => this.newsForm(news))}
        {/*<div className={styles.container}>
          <div className={styles.date}>
            <span>23 августа 2017</span>
          </div>
          <div className={styles.content}>
            <span style={{ fontWeight: "bold" }}>
              23 августа 2017 c 14.00 до 17.00
            </span>{" "}
            в связи с проведением профилактических работ сайт teplo-inform.ru
            может быть недоступен. Сбор данных с приборов будет выполнен в
            штатном режиме.
          </div>
    </div>*/}
      </div>
    );
  }
}

export default News;
